// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Position and sizing of burger button */
.bm-burger-button {
  display: none;
  position: absolute;
  width: 36px;
  height: 30px;
  margin-top: 20px;
  z-index: 0 !important;
}
.bm-burger-button .btn-secondary {
  background-color: #343a40;
  border-color: #343a40;
}

.burger-bar {
  position: absolute;
  height: 100%;
  width: 10px;
  background-color: #343a40;
}

/* Position and sizing of clickable cross button */
.bm-cross-button {
  height: 24px !important;
  width: 24px !important;
  position: relative;
  right: 15px !important;
}

/* Color/shape of close button cross */
.bm-cross {
  background: #828a90;
}

/*
Sidebar wrapper styles
Note: Beware of modifying this element as it can break the animations - you should not need to touch it in most cases
*/
.bm-menu-wrap {
  position: absolute !important;
  width: 250px !important;
  z-index: 10 !important;
  transition: none !important;
}

/* General sidebar styles */
.bm-menu {
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  background: #343a40;
  padding: 2.5em 0.5em 0;
}

/* Wrapper for item list */
.bm-item-list {
  color: white;
  padding: 0.8em;
}

/* Individual item */
.bm-item {
  color: white;
  margin-bottom: 20px;
  text-align: left;
  text-decoration: none;
  transition: color 0.2s;
  font-weight: normal;
  display: block;
}

.bm-item:hover {
  color: #ffffff;
  text-decoration: underline;
}

.bm-subitem {
  display: block;
  font-size: 14px;
  margin-left: 20px;
}

.navbar-content {
  height: 100% !important;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  transition: none !important;
}

.navbar-closed {
  padding-left: 70px;
  margin-right: 30px;
}

.navbar-opened {
  padding-left: 80px;
  margin-left: -100px;
  margin-right: 320px;
}

.page-content {
  position: relative;
}

.navigation-item-active {
  font-weight: bold;
}

.bm-subitem {
  display: block;
  margin-left: 20px;
  font-size: 13px;
}

.hidden-button {
  display: none;
  cursor: none !important;
}

button:has(+ button.hidden-button) {
  display: none;
}

.error-tab {
  color: #d85b61 !important;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/shared/layout/sidebar/sidebar-wrapper.scss","webpack://./node_modules/edozvola-frontend-lib/dist/assets/css/00-settings/_colors.scss"],"names":[],"mappings":"AAEA,yCAAA;AACA;EACE,aAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;AADF;AAGE;EACE,yBCVQ;EDWR,qBCXQ;ADUZ;;AAKA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,yBCnBU;ADiBZ;;AAKA,kDAAA;AACA;EACE,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;AAFF;;AAKA,sCAAA;AACA;EACE,mBCXU;ADSZ;;AAKA;;;CAAA;AAIA;EACE,6BAAA;EACA,uBAAA;EACA,sBAAA;EACA,2BAAA;AAFF;;AAKA,2BAAA;AACA;EACE,gBAAA;EACA,qBAAA;EACA,wBAAA;EACA,mBCnDU;EDoDV,sBAAA;AAFF;;AAKA,0BAAA;AACA;EACE,YAAA;EACA,cAAA;AAFF;;AAKA,oBAAA;AACA;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;AAFF;;AAKA;EACE,cAAA;EACA,0BAAA;AAFF;;AAKA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;AAFF;;AAKA;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAAA;EACA,2BAAA;AAFF;;AAKA;EACE,kBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,iBAAA;AAFF;;AAKA;EACE,cAAA;EACA,iBAAA;EACA,eAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;AAFF;;AAKA;EACE,aAAA;AAFF;;AAKA;EACE,yBAAA;AAFF","sourcesContent":["@import 'edozvola-frontend-lib/dist/assets/css/00-settings/colors';\n\n/* Position and sizing of burger button */\n.bm-burger-button {\n  display: none;\n  position: absolute;\n  width: 36px;\n  height: 30px;\n  margin-top: 20px;\n  z-index: 0 !important;\n\n  .btn-secondary {\n    background-color: $secondary;\n    border-color: $secondary;\n  }\n}\n\n.burger-bar {\n  position: absolute;\n  height: 100%;\n  width: 10px;\n  background-color: $secondary;\n}\n\n/* Position and sizing of clickable cross button */\n.bm-cross-button {\n  height: 24px !important;\n  width: 24px !important;\n  position: relative;\n  right: 15px !important;\n}\n\n/* Color/shape of close button cross */\n.bm-cross {\n  background: $gray-dark;\n}\n\n/*\nSidebar wrapper styles\nNote: Beware of modifying this element as it can break the animations - you should not need to touch it in most cases\n*/\n.bm-menu-wrap {\n  position: absolute !important;\n  width: 250px !important;\n  z-index: 10 !important;\n  transition: none !important;\n}\n\n/* General sidebar styles */\n.bm-menu {\n  overflow-y: auto;\n  scrollbar-width: none;     // Firefox\n  -ms-overflow-style: none;  // IE 10+\n  background: $secondary;\n  padding: 2.5em 0.5em 0;\n}\n\n/* Wrapper for item list */\n.bm-item-list {\n  color: white;\n  padding: 0.8em;\n}\n\n/* Individual item */\n.bm-item {\n  color: white;\n  margin-bottom: 20px;\n  text-align: left;\n  text-decoration: none;\n  transition: color 0.2s;\n  font-weight: normal;\n  display: block;\n}\n\n.bm-item:hover {\n  color: #ffffff;\n  text-decoration: underline;\n}\n\n.bm-subitem {\n  display: block;\n  font-size: 14px;\n  margin-left: 20px;\n}\n\n.navbar-content {\n  height: 100% !important;\n  overflow-x: hidden;\n  overflow-y: auto;\n  scrollbar-width: none;      // Firefox\n  -ms-overflow-style: none;   // IE 10+\n  transition: none !important;\n}\n\n.navbar-closed {\n  padding-left: 70px;\n  margin-right: 30px;\n}\n\n.navbar-opened {\n  padding-left: 80px;\n  margin-left: -100px;\n  margin-right: 320px;\n}\n\n.page-content {\n  position: relative;\n}\n\n.navigation-item-active {\n  font-weight: bold;\n}\n\n.bm-subitem {\n  display: block;\n  margin-left: 20px;\n  font-size: 13px;\n}\n\n.hidden-button {\n  display: none;\n  cursor: none !important;\n}\n\nbutton:has(+ button.hidden-button) {\n  display: none;\n}\n\n.error-tab {\n  color: $red-light !important;\n}\n\n","// Main colors\n$primary: #3a516e;\n$secondary: #343a40;\n\n// Misc Colors\n$green: #17aa55;\n$green-light: #88dda9;\n\n$red: #ca1820;\n$red-light: #d85b61;\n$red-lighter: #e9a7a9;\n$red-lightest: #f4d3d4;\n$yellow: #ffce00;\n\n$blue: #199cb4;\n$blue-light: #5fcde2;\n\n$primary-lighter: #607a9b;\n$primary-lightest: #aaccf8;\n\n$black: #000000;\n$white: #fff;\n\n$gray-dark: #828a90;\n$gray: #adb5bd;\n$gray-light: rgba(233, 236, 239, 0.6);\n$gray-lighter: #f4f5f7;\n\n// Alerts colors\n$success: #19b45a;\n$info: $blue;\n$warning: #f5d8d9;\n$danger: $primary;\n$default: $gray;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
